import {
  Backdrop,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Button
} from '@mui/material'

const UpdateDealDialog = (props) => {
  const {
    open,
    closeModal,
    updateDealHandler,
    isEnough,
    status
  } = props

  return (
    <Backdrop
      open={open}
      className="modal-filter"
    >
      <Dialog
        open={open}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{ textAlign: "center", textTransform: "uppercase" }}
        >
          {status === 5 ? "Close Deal" : "Update Deal"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography
              variant="div"
            >
              {status === 5 ?
                "Are you sure want to close this deal?" :
                status === 4 ?
                  "Are you sure want to set status as Claiming?" :
                  isEnough ?
                    "Are you sure want to set status as Delivering?" :
                    (
                      <>
                        <Typography
                          variant="div"
                        >
                          You can not update the status as Delivering.
                        </Typography>
                        <br />
                        <Typography
                          variant="div"
                        >
                          The staked amount must be at least the minimum sale amount..
                        </Typography>
                      </>
                    )
              }
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          {
            status === 5 ? (
              <Button
                className="btn-info btn-lg"
                onClick={updateDealHandler}
              >
                Close Deal
              </Button>
            ) : status === 4 ? (
              <Button
                className="btn-info btn-lg"
                onClick={updateDealHandler}
              >
                Set Claiming
              </Button>
            ) : isEnough ? (
              <Button
                className="btn-info btn-lg"
                onClick={updateDealHandler}
              >
                Set Delivering
              </Button>
            ) : null
          }

          <Button
            className="btn-default btn-lg"
            onClick={closeModal}
          >
            {status === 3 && !isEnough ? "Close" : "Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
    </Backdrop>
  )
}

export default UpdateDealDialog;